var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing-system"},[_vm._l((_vm.orderList),function(item){return _c('OrderItem',{key:item.orderId,attrs:{"orderItem":item}})}),(!_vm.orderList.length)?_c('Empty'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }